import React from 'react';
import { FaTimes, FaShare } from 'react-icons/fa';
import PropTypes from 'prop-types';

function TypeFilters({ 
  types, 
  selectedTypes, 
  onTypeSelect, 
  onClearFilters,
  showSharedOnly,
  onToggleShared,
  sharedCount
}) {
  const hasFilters = selectedTypes.length > 0 || showSharedOnly;

  if (!types.length) return null;

  return (
    <div className="type-filters">
      <div className="type-filters-header">
        <div className="type-filters-title">Filter by Type</div>
        {hasFilters && (
          <button 
            className="clear-filters-button"
            onClick={onClearFilters}
          >
            <FaTimes /> Clear Filters
          </button>
        )}
      </div>
      <div className="type-chips">
        {types.map(type => (
          <button
            key={type.id}
            className={`type-chip ${selectedTypes.includes(type.id) ? 'selected' : ''}`}
            onClick={() => onTypeSelect(type.id)}
          >
            {type.name}
            <span className="type-count">{type.count}</span>
          </button>
        ))}
        <button
          className={`type-chip ${showSharedOnly ? 'selected' : ''}`}
          onClick={onToggleShared}
        >
          <FaShare /> Shared
          <span className="type-count">{sharedCount}</span>
        </button>
      </div>
    </div>
  );
}

TypeFilters.propTypes = {
  types: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number
  })).isRequired,
  selectedTypes: PropTypes.arrayOf(PropTypes.number).isRequired,
  onTypeSelect: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  showSharedOnly: PropTypes.bool.isRequired,
  onToggleShared: PropTypes.func.isRequired,
  sharedCount: PropTypes.number.isRequired
};

export default TypeFilters;